import { TABLET, PHONE } from './breakpoints';
import { colors, Alert, Card } from '@zopauk/react-components';
import styled, { createGlobalStyle, css } from 'styled-components';

export const QuopaStyles = createGlobalStyle`
  span[role='alert']::before {
    content: none;
  }

  li {
    line-height: 1.5;
  }

  .zopa-modal {
    @media screen and (min-width: ${[PHONE]}px) {
      min-width: 560px;
    }
  }

  .zopa-modal-overlay {
    background-color: rgba(0,0,0,0.8);
  }

  /* TODO: add this to zopa-react-components */
  legend {
    color: ${colors.greyDarkest};
  }
`;

const fullWidthOnMobile = css`
  @media screen and (max-width: ${[PHONE]}px) {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }
`;

export const FullWidthCard = styled(Card)`
  ${fullWidthOnMobile};

  padding: 32px;

  @media screen and (max-width: ${[TABLET]}px) {
    padding: 32px 16px 60px 16px;
  }
`;

export const SemanticCard = styled(Alert)`
  ${fullWidthOnMobile};
`;
